import { FormattedMessage } from 'react-intl';

export type CodeReviewerSettingContainerTypeName = 'repository' | 'workspace';
export type CodeReviewerSettingContainerTypeATI =
  | 'ati:cloud:bitbucket:repository'
  | 'ati:cloud:bitbucket:workspace';
export type CodeReviewerSettingContainerTypeARI =
  | 'ari:cloud:bitbucket::repository'
  | 'ari:cloud:bitbucket::workspace';

export class CodeReviewerSettingContainerType {
  private constructor(
    public readonly name: CodeReviewerSettingContainerTypeName,
    public readonly ati: CodeReviewerSettingContainerTypeATI,
    public readonly ari: CodeReviewerSettingContainerTypeARI
  ) {}

  static readonly Repository: CodeReviewerSettingContainerType =
    new CodeReviewerSettingContainerType(
      'repository',
      'ati:cloud:bitbucket:repository',
      'ari:cloud:bitbucket::repository'
    );
  static readonly Workspace: CodeReviewerSettingContainerType =
    new CodeReviewerSettingContainerType(
      'workspace',
      'ati:cloud:bitbucket:workspace',
      'ari:cloud:bitbucket::workspace'
    );
}

export type CodeReviewerRepositorySetting = {
  error: FormattedMessage.MessageDescriptor | null;
  isLoading: boolean;
  isEnabledAtRepository: boolean;
  isEnabledAtWorkspace: boolean;
  isRepositoryDisabledForAutoreview: boolean;
  updateRepositorySetting: () => void;
};

export type CodeReviewerWorkspaceSetting = {
  error: FormattedMessage.MessageDescriptor | null;
  isLoading: boolean;
  isEnabledAtWorkspace: boolean;
  updateWorkspaceSetting: () => void;
};

export type CodeReviewerSetting = Omit<
  CodeReviewerRepositorySetting,
  'updateRepositorySetting'
> &
  Omit<CodeReviewerWorkspaceSetting, 'updateWorkspaceSetting'> & {
    updateContainerSetting: () => void;
  };
